import React from "react";
import PropTypes from "prop-types";
import { validateEmail } from "lib/utils";

export default class Input extends React.Component {
  componentWillMount() {
    this.setState({ invalid: this.props.invalid || "" });
  }

  componentWillReceiveProps(props) {
    this.setState({ invalid: props.invalid });
  }

  static propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["text", "password", "email"]).isRequired,
    cssClass: PropTypes.string,
    defaultValue: PropTypes.string,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    required: PropTypes.bool,
    autofocus: PropTypes.bool,
    disabled: PropTypes.bool,
  };

  CheckIfValid = (element) => {
    const { type } = this.props;
    let invalid = false;
    if (element.target.ariaRequired === "true" && element.target.value === "") {
      invalid = true;
    }

    if (type === "email") {
      if (validateEmail(element.target.value)) {
        invalid = true;
      }
    }

    this.setState({ invalid });
  };
  debugger;
  render() {
    let {
      id,
      name,
      type,
      placeholder,
      cssClass,
      defaultValue,
      required,
      autofocus,
      style,
      disabled,
    } = this.props;

    const { invalid } = this.state;

    return (
      <input
        autoFocus={autofocus}
        //{...autofocus && autofocus != "" && { autofocus: autofocus }}
        id={id}
        name={name}
        type={type}
        ref={this.props.inputValue}
        className={cssClass}
        placeholder={placeholder}
        defaultValue={defaultValue}
        aria-required={required}
        aria-invalid={invalid}
        disabled={disabled}
        onBlur={this.CheckIfValid}
        onChange={this.props.onChange}
      />
    );
  }
}

Input.defaultProps = {
  name: "",
  placeholder: "",
  defaultValue: "",
  required: "",
  required: false,
  autofocus: false,
  style: {},
};
